import { render, staticRenderFns } from "./add.vue?vue&type=template&id=08f86b50&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=08f86b50&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f86b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f86b50')) {
      api.createRecord('08f86b50', component.options)
    } else {
      api.reload('08f86b50', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=08f86b50&scoped=true", function () {
      api.rerender('08f86b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchase/supplier/add.vue"
export default component.exports